import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';

import { BusinessInvoiceHandler } from '../../providers/business-invoice-handler';

import { BusinessInvoiceDetailPage } from '../../pages/business-invoice-detail/business-invoice-detail';

@Component({
  selector: 'page-business-invoice-list',
  templateUrl: 'business-invoice-list.html',
})
export class BusinessInvoiceListPage {
	isRefreshing: boolean = false;
	isLoading: boolean = false;
	isFetchingMore: boolean = false;
	
	loadingMsg: any = "Loading...";

	page: any = 1;
	size: any = 20;

	lastRequestReturnedValues: boolean = false;

	list: any = [];
	hasData: boolean = true;

	constructor(
		public businessInvoiceHandler: BusinessInvoiceHandler,
		public navCtrl: NavController, 
		public toastCtrl: ToastController,
		public navParams: NavParams) {
		this.load(null);
	}

	doRefresh(refresher) {
		this.isRefreshing = true;
		this.page = 1;
				
		this.load(()=>{
		  refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isFetchingMore = true;
		this.page++;

		this.load(()=>{
			infiniteScroll.complete();
		});
	}

	load(cb){
		this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

		this.businessInvoiceHandler.getBusinessInvoice({page: this.page, size: this.size})
		.then((data: any)=>{
			var list = data.Data;
			
			this.hasData = (list.length == 0 && this.page == 1) ? false : true;
			this.lastRequestReturnedValues = (list.length==0) ? false : true;

			if(this.page == 1){
				this.list = list;	
			}else{
				for (var i = list.length - 1; i >= 0; i--) {
					this.list.push(list[i]);
				}					
			}
			
			this.isLoading = false;			

			if(typeof cb == "function") cb();
		})
		.catch((err)=>{
			this.isLoading = false;	

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'bottom'
			});

			toast.present();	
		});
	}	

	viewDetail(invoice){
		this.navCtrl.push(BusinessInvoiceDetailPage, {invoice: invoice});		
	}
}



// WEBPACK FOOTER //
// ./src/pages/business-invoice-list/business-invoice-list.ts